import { createAsyncThunk , createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { config , baseUrl } from "../../utils/baseUrl";

export const fetchQuizDetailsAction = createAsyncThunk('quiz/details',async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            token : localStorage.getItem("token"),
        }

        const {data} = await axios.post(`${baseUrl}/api/quiz/quizDetails`,sendData,config);

        return data;

    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

export const solveQuizAction = createAsyncThunk('quiz/solve',async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            token : localStorage.getItem("token"),
            questionId : payload?.questionId,
            answer : payload?.answer,
        }

        const {data} = await axios.put(`${baseUrl}/api/quiz/solved`,sendData,config);

        return data;

    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

export const deleteQuiz = createAsyncThunk('quiz/delete',async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        const sendData = {
            token : localStorage.getItem("token"),
            quizId : payload?.quizId,
        }

        const {data} = await axios.put(`${baseUrl}/api/quiz/delete`,sendData,config);

        return data;

    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});


export const quizmessageDeleteAction = createAsyncThunk('message/delete',async(payload,{rejectWithValue,getState,dispatch})=>{
    try {
        // Delete message;
    } catch (error) {
        if(error?.response){
            return rejectWithValue(error?.response?.data);
        }else{
            throw error;
        }
    }
});

const quizSlice = createSlice({
    name : "quiz",

    initialState : {
        presentQuiz : null,
        pastQuiz : null,
    },

    extraReducers : (builder)=>{

        //fetch details
        builder.addCase(fetchQuizDetailsAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(fetchQuizDetailsAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.presentQuiz = action?.payload?.presentQuiz;
            state.pastQuiz = action?.payload?.pastQuiz;
            state.solved = action?.payload?.solved;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(fetchQuizDetailsAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });

        //solve quiz
        builder.addCase(solveQuizAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(solveQuizAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.presentQuiz = action?.payload?.updatedQuiz;
            state.user = action?.payload?.user;
            state.solved = action?.payload?.solved;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(solveQuizAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });

        //delete quiz
        builder.addCase(deleteQuiz.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(deleteQuiz.fulfilled,(state,action)=>{
            state.loading = false;
            state.message = action?.payload?.message;
            state.presentQuiz = action?.payload?.presentQuiz;
            state.pastQuiz = action?.payload?.pastQuiz;
            state.solved = action?.payload?.solved;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(deleteQuiz.rejected,(state,action)=>{
            state.loading = false;
            state.appError = action?.payload?.message;
            state.serveError = action?.payload?.message;
        });

        //delete message
        builder.addCase(quizmessageDeleteAction.pending,(state,action)=>{
            state.loading = true;
        });
        builder.addCase(quizmessageDeleteAction.fulfilled,(state,action)=>{
            state.loading = false;
            state.message = null;
            state.appError = null;
            state.serveError = null;
        });
        builder.addCase(quizmessageDeleteAction.rejected,(state,action)=>{
            state.loading = false;
            state.appError = null;
            state.serveError = null;
        });

    }

})

export default quizSlice.reducer;